import PropTypes from 'prop-types';

export default PropTypes.shape({
  email: PropTypes.string,
  fullname: PropTypes.string,
  id: PropTypes.string,
  isAdmin: PropTypes.bool,
  isSpoofing: PropTypes.bool,
});
